<div class="modal-header" id="file-path-modal-title">
    <h3 class="modal-title" id="modal-title" translate="WINDOWS_REPORT_ISSUE_MODAL_TITLE"></h3>
</div>
<div class="modal-body" id="modal-body">
    <div class="row">
        <ul>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_1"></li>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_2"></li>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_3"></li>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_4"></li>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_5"></li>
            <li translate="WINDOWS_REPORT_ISSUE_MODAL_INSTRUCTION_6"></li>
        </ul>
    </div>
    <div class="row">
        <textarea
            #textAreaElement
            class="col"
            [readOnly]="true"
            rows="3"
            [attr.aria-label]="'WINDOWS_REPORT_ISSUE_MODAL_FILE_PATH_LABEL' | translate"
        >
            {{ model.filePath }}
        </textarea>
    </div>
</div>
<div class="modal-footer">
    <button
        class="btn btn-secondary"
        (click)="onCopyClicked()"
        translate="WINDOWS_REPORT_ISSUE_MODAL_ACTION_COPY"
    ></button>
    <button
        class="btn btn-primary"
        (click)="onCloseClicked()"
        translate="WINDOWS_REPORT_ISSUE_MODAL_ACTION_CLOSE"
    ></button>
</div>
